// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/zugfeder-im-bereich-der-sitze-im-pkw/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteZugfederImBereichDerSitzeImPkwDE: PageEntry = {
  id: "example.produkte-zugfeder-im-bereich-der-sitze-im-pkw",
  locale: "de",
  slug: "produkte/zugfeder-im-bereich-der-sitze-im-pkw",
  seo: {
    title: "Zugfeder im Bereich der Sitze im PKW | Dietz GmbH",
    description: "Die Sonderform der Öse erfordert spezielle Werkzeugausführung für die Fertigung auf einer Zugfedermaschine",
  },
  type: "post",
  h1: "Zugfeder im Bereich der Sitze im PKW",
  intro: "Die Sonderform der Öse erfordert spezielle Werkzeugausführung für die Fertigung auf einer Zugfedermaschine",
  blocks: [
    { kind: "image", src: "/images/live/zugfeder.jpg", alt: "Zugfeder im Bereich der Sitze im PKW", width: 1400, height: 1120 }
  ],
};
